import { ErrandResponse } from '@backend/schemas/src/errands'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'


export const ErrandStatusLabel = ({ status }: { status: ErrandResponse['status'] }) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-2">
      <div
        className={cn('size-2.5 rounded-full', {
          'bg-error': status === 'rejected',
          'bg-info': status === 'submitted',
          'bg-success': status === 'approved',
          'bg-text-helper': status === 'started',
        })}
      />
      <p>{t(`errandStatus.${status}`)}</p>
    </div>
  )
}
